import { action, observable } from 'mobx';
import Alert from 'react-s-alert';

import { AppManager, App, Input } from 'core';

import { FormStore } from 'libs/forms/app';

import { ChangePasswordMutation } from 'apps/profile/gql';
import { conf } from 'apps/profile/settings/config.yaml';

class ChangePasswordApp extends App {
  static registryName = 'ChangePasswordApp';
  @observable currentPassword = '';
  @observable newPassword = '';
  init() {
    this.form = new FormStore(this, conf, 'changePasswordForm', '', false);
  }

  @action
  Submit = () => {
    if (this.form.isValid) {
      const input = new Input({
        currentPassword: this.currentPassword,
        newPassword: this.newPassword,
      });
      this.manager.Submit(input, {
        onSysErr: this.onError,
        onUserErr: this.onError,
        onSuccess: this.onSuccess,
      });
    } else {
      this.form.alert();
    }
  };

  @action
  onError = () => {
    Alert.error('Hmm... We failed to change your password. Please try again.');
  };

  @action
  onSuccess = result => {
    if (result.result === 'fail' && result.msg === 'incpw') {
      Alert.error("Your current password didn't match. Please try again.");
      this.currentPassword = '';
    } else if (result.result === 'ok') {
      Alert.success('Password changed successfully!');
      this.currentPassword = '';
      this.newPassword = '';
    }
  };
}

export class ChangePasswordAppManager extends AppManager {
  static registryName = 'ChangePasswordAppManager';
  constructor(parent, init = {}) {
    super(parent, init);
    this.app = new ChangePasswordApp(this, {});
    this.app.init();
  }

  @action
  Submit = (input, options) => {
    this.mutations.push(ChangePasswordMutation.New(input, options));
  };
}
